<script lang='ts'>
  import getScales from './scales'
  import ScalesList from './ScalesList.svelte'

  let scales = []
  let errorMessage = ''

  function loadScales(event) {
    let n = event.target.form[0].value
    let k = event.target.form[1].value
    const response = getScales(parseInt(n), parseInt(k))
    errorMessage = response.error
    scales = response.scales
  }
</script>

<main>
  <div id="controls">
    <div id="intro">
      <h1>All those Scales</h1>
      <p>
        This app calculates all possible musical scales consisting of a given number of notes in a given range. For example,
        a major scale consists of 7 notes and spans an octave, whereas the Messiaen modes of limited transposition consist of 1 to 5 notes and
        span 2, 3, 4 or 6 semitones. 
      </p>
      <p>
        Suppose you want to see what other 7-note scales spanning an octave there are except the major scale. Then you may enter the values
        12 for <b>Range</b> and 7 for <b>Notes</b> to see a list of all theoretically possible scales.<br>
        Many of the scales may not sound very pleasing to you. The algorithm doesn't make creative choices.
      </p>
      <p>
        But, the algorithm does decide to omit scales, that can be derived by rotation from scales, that are already listed. This means, that the 
        major and the minor scales aren't listed separately (In fact, the algorithm lists the Locrian scale instead of the major scale).
      </p>
      <h3>How to interprete the output</h3>
      <p>Consider this example: </p>
      <p>2 2 1 2 2 2 1</p>
      <p>
        What it means, is that between the first and the second note there is a whole tone. Between the second and the third it's also a whole tone.
        Between the third and the fourth there is a semitone. And so on. So the example you're seeing is a major scale.
      </p>
    </div>
    <form>
      <div class="form-control">
        <label for="n-input">Range</label>
        <input type="number" name="n-input" id="n-input" min="0" max="12">  
      </div>
      <div class="form-control">
        <label for="k-input">Notes</label>
        <input type="number" name="k-input" id="k-input" min="0" max="12">
      </div>
      <input type="submit" on:click|preventDefault={loadScales} value="Submit">
      <p id="error-message">{errorMessage}</p>
    </form>
    <footer>
      <p>
        <a href="https://www.ilja-rotar.de/privacy.html" target="_blank">Privacy Policy</a>
      </p>
    </footer>
  </div>
  <div id="output">
      {#if scales}
        <ScalesList scales={scales}/>
      {/if}
  </div>
</main>

<style>
  .form-control {
    margin-top: 1.5em;
  }
  form {
    margin-bottom: 3em;
  }
  input {
    max-width: 100%;
  }
  #controls {
    box-shadow: 0 7px 10px lightgrey;
    padding: 1.5em;
    margin-bottom: 3em;
    background-color: white;
    border-radius: 5px;
  }
  main {
    width: 95%;
    min-height: 100%;
    overflow: auto;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  #output {
    margin-bottom: 3em;
  }
  footer {
    text-align: right;
  }
  footer>p {
    margin: 0;
  }
  #error-message {
    color: #ee1111;
    position: absolute;
  }
  #intro {
    max-width: 1200px;
  }
</style>
